import {MEETING_PENDING} from '../../constants/meetingState';

export function isMeetingUnconfirmed(meeting) {
    return meeting.state == MEETING_PENDING && moment().isSameOrBefore(meeting.start_local);
}
